import React from 'react'
import { Link } from 'react-router-dom'

const UnderstandUsersExpectation = () => {
  return (
    <div>
        <section className="funfacts-area ptb-80">
  <div className="container">
    <div className="section-title">
      <h2 className='fontkumbh'>We always try to understand users expectation</h2>
      <div className="bar" />
      <p>
        We help our clients to solve their hardest issues. We provide proficient
        ITES Development services according to your necessities in reasonable
        expense. Few facts which explore us most.
      </p>
    </div>
    <div className="row">
      <div className="col-12">
        <img
          src="assets/img/all-banner/expectation-banner.webp"
          alt="Web Designing"
          style={{ width: "100%" }}
          loading="lazy"
        />
      </div>
    </div>
    <div className="contact-cta-box">
      <h3 className='fontkumbh'>Have any question about us?</h3>
      <p className='mobile-p-center'>Don't hesitate to contact us</p>{" "}
      <Link to="/contact-us" className="btn btn-primary">
        Contact Us
      </Link>
    </div>
    {/* <div class="map-bg">
				<img src="assets/img/map.webp" alt="map">
			</div> */}
  </div>
  <div className="shape1">
    <img src="assets/img/shape1.webp" alt="shape" loading="lazy" />
  </div>
  <div className="shape4">
    <img src="assets/img/shape4.svg" alt="shape" loading="lazy" />
  </div>
</section>

    </div>
  )
}

export default UnderstandUsersExpectation